import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Calendar } from 'lucide-react';
import '../../Styles/yellowcalfcss/EditBill.css';

export default function CreateBill() {
  const [billNumber, setBillNumber] = useState('DFKDJ');
  const [supplier, setSupplier] = useState('');
  const [billDate, setBillDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [currentItem, setCurrentItem] = useState('');
  const [currentQuantity, setCurrentQuantity] = useState('');
  const [currentUnitPrice, setCurrentUnitPrice] = useState('');
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [showItemValidation, setShowItemValidation] = useState();
  const [showQuantityValidation, setShowQuantityValidation] = useState(false);
  const [showPriceValidation, setShowPriceValidation] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const calculateItemTotal = () => {
    const qty = parseFloat(currentQuantity) || 0;
    const price = parseFloat(currentUnitPrice) || 0;
    return qty * price;
  };

  const addItem = () => {
    setShowItemValidation(!currentItem);
    setShowQuantityValidation(!currentQuantity);
    setShowPriceValidation(!currentUnitPrice);

    if (currentItem && currentQuantity && currentUnitPrice) {
      const newItem = {
        item: currentItem,
        quantity: parseFloat(currentQuantity),
        unitPrice: parseFloat(currentUnitPrice),
        total: calculateItemTotal()
      };
      setItems([...items, newItem]);
      setCurrentItem('');
      setCurrentQuantity('');
      setCurrentUnitPrice('');
      setShowItemValidation(false);
      setShowQuantityValidation(false);
      setShowPriceValidation(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!billNumber.trim()) {
      newErrors.billNumber = 'Bill Number cannot be blank';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = () => {
    if (validateForm()) {
      setSuccessMessage('Bill Updated successfully!');
    }
  };

  return (
    <div className="invoice-outer-shell">
      <div className="invoice-content-zone">
        <div className="invoice-heading-panel">
          <h3>Update Bill</h3>
        </div>

        {successMessage && (
          <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible className="invoice-notification-bar">
            {successMessage}
          </Alert>
        )}

        <div className="invoice-field-container" style={{height:'90px'}}>
          <div className="invoice-dual-column" style={{marginTop:'-15px'}}>
            <Form.Group controlId="billNumber">
              <Form.Label >
                Bill Number <span className="invoice-mandatory-mark">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter bill number"
                value={billNumber}
                onChange={(e) => setBillNumber(e.target.value)}
                isInvalid={!!errors.billNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.billNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="supplier">
              <Form.Label>
                Supplier <span className="invoice-mandatory-mark">*</span>
              </Form.Label>
              <Form.Select
                value={supplier}
                onChange={(e) => setSupplier(e.target.value)}
              >
                <option value="" selected="">Sipin</option>
                <option value="supplier1">Vipin</option>
                <option value="supplier2">AKBAR SHAN</option>
                <option value="supplier3">ANTHINY</option>
                <option value="supplier4">AMAR</option>
              </Form.Select>
            </Form.Group>
          </div>
        </div>

        <div className="invoice-field-container"style={{height:'90px'}} >
          <div className="invoice-dual-column"style={{marginTop:'-15px'}}>
            <Form.Group controlId="billDate">
              <Form.Label>Bill Date</Form.Label>
              <div className="invoice-calendar-wrapper">
                <Form.Control
                  type="date"
                  value={billDate}
                  onChange={(e) => setBillDate(e.target.value)}
                  className="invoice-datepicker-input"
                />
              </div>
            </Form.Group>

            <Form.Group controlId="dueDate">
              <Form.Label>Due Date</Form.Label>
              <div className="invoice-calendar-wrapper">
                <Form.Control
                  type="date"
                  value={dueDate}
                  onChange={(e) => setDueDate(e.target.value)}
                  className="invoice-datepicker-input"
                />
             
              </div>
            </Form.Group>
          </div>
        </div>

        <div className="invoice-field-container" style={{height:'99px'}}>
          <div className="invoice-quad-layout"style={{marginTop:'-11px'}}>
            <Form.Group>
              <Form.Label>Item</Form.Label>
              <Form.Control
                type="text"
                value={currentItem}
                onChange={(e) => setCurrentItem(e.target.value)}
                placeholder="Item"
                isInvalid={showItemValidation && !currentItem}
              />
              <Form.Control.Feedback type="invalid">
                This field is required.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                value={currentQuantity}
                onChange={(e) => setCurrentQuantity(e.target.value)}
                placeholder="0"
                isInvalid={showQuantityValidation && !currentQuantity}
              />
              <Form.Control.Feedback type="invalid">
                This field is required.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Form.Label>Unit Price</Form.Label>
              <Form.Control
                type="number"
                value={currentUnitPrice}
                onChange={(e) => setCurrentUnitPrice(e.target.value)}
                placeholder="0.00"
                isInvalid={showPriceValidation && !currentUnitPrice}
              />
              <Form.Control.Feedback type="invalid">
                This field is required.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group>
              <Form.Label>Item Total</Form.Label>
              <div className="invoice-calculation-bundle">
                <Form.Control
                  type="number"
                  value={calculateItemTotal().toFixed(2)}
                  readOnly
                />
                <Button
                  onClick={addItem}
                  className="invoice-append-trigger"
                >
                  +
                </Button>
              </div>
            </Form.Group>
          </div>
        </div>

        {items.length > 0 && (
          <>
            <div className="invoice-products-banner">
              <h5>Added Items</h5>
            </div>

            <div className="invoice-column-labels">
              <div className="invoice-grid-columns">
                <div>Item</div>
                <div>Quantity</div>
                <div>Unit Price</div>
                <div>Total</div>
              </div>
            </div>

            <div className="invoice-entries-collection">
              {items.map((item, index) => (
                <div key={index} className="invoice-product-record">
                  <div className="invoice-grid-columns">
                    <div>{item.item}</div>
                    <div>{item.quantity}</div>
                    <div>${item.unitPrice.toFixed(2)}</div>
                    <div>${item.total.toFixed(2)}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
<div className="invoice-action-box">
  <Button
    onClick={handleCreate}
    className="invoice-confirm-action"
    style={{  display: 'block' , height: '47px' , width: '120px' , marginTop:'-18px',marginLeft:'-10px' }}
  >
    Update Bill
  </Button>
</div>


      </div>
    </div>
  );
}
